import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=33031f2a&scoped=true&"
var script = {}
import style0 from "./HomePage.vue?vue&type=style&index=0&id=33031f2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33031f2a",
  null
  
)

export default component.exports